export default __webpack_public_path__ + "4e00e9a3e6488a6d3590fb08f81d892b.png";